export default __webpack_public_path__ + "static/8grafpro-33b0f2511969865f97889f413573fd44.png";